import React from 'react';
import { TrackingObject } from '~/shared/utils/gtm/lib/model';

type GtmContextType = TrackingObject & {
    referer?: string;
};

export const GtmContext = React.createContext<GtmContextType>({} as GtmContextType);
